import { createCaseTabsStore } from '@features/store/case-tabs.store';

export const useCaseTabsStore = createCaseTabsStore({
  storageKey: 'cases-tabs',
  version: 2,
});

// Re-export type for convenience
export type { CaseTabType } from '@features/store/case-tabs.store';
